import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import SimpleTable from "../../../components/SimpleTable";
import { useNavigate } from "react-router-dom";
import { deleteData, fetchData } from "../../Utils/Baseurl";
import { Stack } from "@mui/material";
import Swal from "sweetalert2";
import { useSnackbar } from "../../../components/SnackbarProvider";
import CanAccess from "../../../components/permission/CanAccess";
import { useAuth } from "../../../context/AuthContext";

const EmployeeMaster = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const { rolePermission } = useAuth();

  useEffect(() => {
    getEmplyoeeList();
  }, []);

  // emplyooee list
  const getEmplyoeeList = async () => {
    setIsLoading(true);
    try {
      const response = await fetchData("api/create_user/");

      if (response?.status && Array.isArray(response.data)) {
        setList(response.data);
      } else {
        setList([]);
      }
    } catch (error) {
      console.error("Error while fetching role list:", error);
      setList([]);
    } finally {
      setIsLoading(false);
    }
  };
  //   Delete Designation with Confirmation

  const deleteEmployee = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure you want to delete this Employee?",
      text: "This action is irreversible and cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await deleteData(`api/create_user/${row}/`);

        if (response.status) {
          showSnackbar(response?.message, "success");
          getEmplyoeeList();
        } else {
          showSnackbar(response?.message, "error");
        }
      } catch (error) {
        console.log(error);

        let message = "An unexpected error occurred";

        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (error?.message) {
          message = error.message;
        }

        showSnackbar(message, "error");
      }
    }
  };

  // Table column data
  const userColumns = [
    { header: "NAME", key: "name" },
    { header: "EMAIL", key: "email" },
    { header: "DEPT", key: "department" },
    { header: "ROLE", key: "role" },
    { header: "ACTION", key: "action" },
  ];
  // Table row data
  const userData = list.map((item) => ({
    id: item?.id,
    name: item?.employee_name,
    email: item?.email,
    department: item?.department?.department_name,
    role: item?.role?.role,
  }));

  // add function
  const handleDialogOpen = () => {
    navigate("/employee-master/add-emplyoee");
  };
  // edit function
  const employeeEdit = (id) => {
    navigate("/employee-master/add-emplyoee", {
      state: { data: id, type: "edit" },
    });
  };
  // view function
  const employeeView = (id) => {
    navigate("/employee-master/add-emplyoee", {
      state: { data: id, type: "view" },
    });
  };

  // role permission for table
  const actionVisibility = {
    showEdit: CanAccess.can(rolePermission, "Employee Master", "Employee Edit"),
    showView: CanAccess.can(rolePermission, "Employee Master", "Employee View"),
    showDelete: CanAccess.can(
      rolePermission,
      "Employee Master",
      "Employee Delete"
    ),
  };
  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Employee Master
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the employee list here.
          </MaterialTypography>
        </Stack>
        {/* <CanAccess module="Employee Master" component="Employee Add"> */}
          <MaterialButton
            variant="gradient"
            color="dark"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleDialogOpen}
          >
            Employee
          </MaterialButton>
        {/* </CanAccess> */}
      </Stack>

      <SimpleTable
        columns={userColumns}
        data={userData}
        onEdit={employeeEdit}
        onDelete={deleteEmployee}
        onView={employeeView}
        isLoading={isLoading}
        actionVisibility={actionVisibility}
      />
    </DashboardLayout>
  );
};

export default EmployeeMaster;
